import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M12.72 15.78a.75.75 0 01-.53.22h-.38a.77.77 0 01-.53-.22l-5.13-5.14a.5.5 0 010-.71l.71-.71a.49.49 0 01.7 0L12 13.67l4.44-4.45a.5.5 0 01.71 0l.7.71a.5.5 0 010 .71l-5.13 5.14z" fill="currentColor" /></svg>);